import React from 'react';
import { Input, Button } from 'antd';
import { OTP_VERIFICATION_TEXTS, CONTACTS} from '../helpers/misc';

const OtpVerification = ({ 
  otp, 
  cardNumber,
  resendOtpAvailable, 
  resendOtpCountdown, 
  onOtpChange, 
  onVerifyOtp, 
  onResendOtp 
}) => {
  const handleOtpInputChange = (e) => {
    onOtpChange(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && otp) {
      onVerifyOtp();
    }
  };

  return (
    <div className="verification-box">
      <div style={{ margin: "1em 0 2em", textAlign: 'center' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '.5em', color: "#142654" }}>Vaše číslo karty BENU</label>
        <Input
          value={cardNumber}
          disabled
          style={{ textAlign: 'center' }}
        />
      </div>
      <div className="instruction">{OTP_VERIFICATION_TEXTS.instruction}</div>
      <p>{OTP_VERIFICATION_TEXTS.info}</p>
      <div>
        <Input
          placeholder={OTP_VERIFICATION_TEXTS.placeholder}
          value={otp}
          onChange={handleOtpInputChange}
          onKeyDown={handleKeyDown}
          style={{ margin: "1em 0", textAlign: 'center' }}
        />
      </div>

      
      <Button 
        type="primary" 
        onClick={onVerifyOtp}
        disabled={!otp}
        style={{margin: "1em 0"}}
      >
        {OTP_VERIFICATION_TEXTS.verifyButton}
      </Button>
      
      <p>
        <span style={{display: "block"}}>{OTP_VERIFICATION_TEXTS.codeInfo}</span>
        <span style={{display: "block"}}>{OTP_VERIFICATION_TEXTS.resendQuestion}{' '}
          <Button
            type="link"
            onClick={onResendOtp}
            disabled={!resendOtpAvailable}
            style={{ padding: 0 }}
          >
          {OTP_VERIFICATION_TEXTS.resendButton} {resendOtpAvailable ? '' : `(${resendOtpCountdown}s)`}
        </Button></span>
      </p>

      <p>
        {OTP_VERIFICATION_TEXTS.supportInfoPart1}{" "}
        <a className="verification-contact" href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a>{" "}
        {OTP_VERIFICATION_TEXTS.supportInfoPart2}{" "}
        <a className="verification-contact" href={`tel:${CONTACTS.phone.replace(/\s/g, "")}`}>
          {CONTACTS.phone}
        </a>{" "}
        {OTP_VERIFICATION_TEXTS.supportInfoPart3}
      </p>
    </div>
  );
};

export default OtpVerification;
